export default __webpack_public_path__ + "static/media/Wycliffe College.94083d8d.png";